<template>
  <div class="footer">
    星邮供应链有限公司
  </div>
</template>

<script>
export default {
  name: "sp-footer",
  props: {},
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
.footer{
  text-align: center;
  margin: 0 -20px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/sp-footer.vue